var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// packages/remirror__extension-trailing-node/src/index.ts
var src_exports = {};
__export(src_exports, {
  TrailingNodeExtension: () => TrailingNodeExtension
});
module.exports = __toCommonJS(src_exports);

// packages/remirror__extension-trailing-node/src/trailing-node-extension.ts
var import_core = require("@remirror/core");
var import_trailing_node = require("@remirror/pm/trailing-node");
var TrailingNodeExtension = class extends import_core.PlainExtension {
  get name() {
    return "trailingNode";
  }
  /**
   * Whenever the options are changed make sure to update the plugin with the
   * new values and trigger a state update.
   */
  onSetOptions(props) {
    const { changes } = props;
    if (changes.disableTags.changed || changes.ignoredNodes.changed || changes.nodeName.changed) {
      this.store.updateExtensionPlugins(this);
    }
  }
  /**
   * Add the trailing node plugin to the editor.
   */
  createExternalPlugins() {
    const { tags } = this.store;
    const { disableTags, nodeName } = this.options;
    const ignoredNodes = disableTags ? [...this.options.ignoredNodes] : [...this.options.ignoredNodes, ...tags.lastNodeCompatible];
    return [(0, import_trailing_node.trailingNode)({ ignoredNodes, nodeName })];
  }
};
TrailingNodeExtension = __decorateClass([
  (0, import_core.extension)({
    defaultOptions: {
      ignoredNodes: [],
      disableTags: false,
      nodeName: "paragraph"
    }
  })
], TrailingNodeExtension);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  TrailingNodeExtension
});
